import app from '@/app.js';
import { createVuetify } from 'vuetify';
import { aliases, md } from 'vuetify/iconsets/md';
import colors from 'vuetify/util/colors';

// common config for all input components
const inputConfig = {
  attach: true,
  color: 'primary',
  clearIcon: 'clear',
  hideDetails: false,
  variant: 'outlined',
  density: 'compact',
  rounded: 'lg'
};

// this is used to set the default props for all components globally
const defaults = {
  VTextField: {
    ...inputConfig,
  },
  VAutocomplete: {
    ...inputConfig,
    autocomplete: 'off',
  },
  VTextarea: {
    ...inputConfig,
  },
  VSelect: {
    ...inputConfig,
  },
  VCard: {
    elevation: 0,
  },
  VBtn: {
    elevation: 0,
    large: true,
    dense: true,
    rounded: true,
    disabledColor: 'disabled',
  },
  VCheckboxBtn: {
    color: 'primary',
  },
  VAlert: {
    outlined: true,
    elevation: 0,
  },
  VListItem: {
    color: 'primary',
  },
  VCheckbox: {
    color: 'primary',
    density: 'compact',
  },
  VSwitch: {
    color: 'primary',
  },
  VRadio: {
    color: 'primary',
  },
  VLink: {
    color: 'primary',
  },
}

const vuetify = createVuetify({
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
    },
  },
  // set the default component prop values
  defaults,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: colors.orange.darken2,
          secondary: colors.grey.darken3,
          accent: colors.orange.darken2,
          error: colors.red.darken1,
          warning: colors.yellow.darken2,
          info: colors.blue.darken1,
          highlight: colors.blue.darken1,
          success: colors.green.darken1,
          disabled: colors.grey.lighten1,
        },
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 420,
    },
    scrollbarWidth: 10,
  },
});

app.use(vuetify);

export default vuetify;

export { inputConfig, defaults };
